import { Rating } from "react-simple-star-rating";
import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../Common/CommonCardHeader";
import { RatingWithTooltip } from "../../../Constant";
import { FILL_COLOR, TOOLTIP_RATING, TOOLTIP_ARRAY } from "../../../Data/Bonus Ui/Rating";

const IconsCount = () => {

  return (
    <Col xl="4" md="6">
      <Card>
        <CommonCardHeader title={RatingWithTooltip} span={TOOLTIP_RATING} />
        <CardBody>
          <div style={{direction: "ltr",touchAction: "none"}}>
            <Rating fillColorArray={FILL_COLOR} iconsCount={10} showTooltip tooltipArray={TOOLTIP_ARRAY} transition/>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default IconsCount;
